var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadsetIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m90.11,37.35C89.35,24.7,79.94,1.06,50,.01c-.18,0-.37-.02-.56,0C19.95,1.34,10.65,24.78,9.89,37.35v11.62h0v24.71c0,6.14,4.98,11.12,11.12,11.12h14.3v-35.83h-17.96v-11.26c.17-2.2,2.86-29.07,32.66-30.27,29.83,1.2,32.5,28.13,32.66,30.26v11.26h-17.96v35.83h25.42v-47.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m75.74,90.68h-25.52v9.32h26.09l.25-.03c4.69-.5,13.56-4.32,13.56-15.18h-9.32c0,4.63-3.69,5.67-5.06,5.89Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadsetIcon);
export default __webpack_public_path__ + "static/media/HeadsetIcon.772316c6a8813603c437f6b37308fb56.svg";
export { ForwardRef as ReactComponent };